import React from "react"
import { NavItemWrapper } from "./MainNavigation"
import { useIntl } from "react-intl"
import { Paths } from "#/utils/Paths"

export function CarrotCollectiveNavItem({ onClick }: { onClick: () => void }): JSX.Element {
  const intl = useIntl()

  return (
    <>
      <NavItemWrapper
        link={Paths.EXCLUSIVE_DISCOUNTS}
        onClick={onClick}
        text={intl.formatMessage({ defaultMessage: "Exclusive discounts" })}
      />
    </>
  )
}
